<template>
	<v-tooltip max-width="800" top color="black" :disabled="isNovaMarcaVazia">
		<template #activator="{ on }">
			<v-text-field
				v-on="on"
				:id="`item-aditivo-apostila${itemAditivoApostila.id}-nova-marca`"
				v-model.trim="itemAditivoApostila.novaMarca"
				clearable
				type="string"
				class="pt-3 mt-1"
				placeholder="Informe"
				@input="eventoAlteracao"
				:disabled="disabled"
			>
			</v-text-field>
		</template>
		<span>{{ itemAditivoApostila.novaMarca }}</span>
	</v-tooltip>
</template>
<script>
import {actionTypes} from "@/core/constants";

export default {
	name: 'alterar-marca-item-aditivo-apostila',
	props: {
		itemSelecionado: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: null,
		},
	},
	data() {
		return {
			itemAditivoApostila: this.itemSelecionado,
			alterarMarcaTimeout: null,
		}
	},
	computed: {
		isNovaMarcaVazia: {
			get() {
				return !this.itemAditivoApostila.novaMarca
			},
		},
	},
	methods: {
		async eventoAlteracao() {
			clearTimeout(this.alterarMarcaTimeout)
			const evento = async function () {
				await this.alterarMarca()
			}.bind(this)
			this.alterarMarcaTimeout = setTimeout(evento, 1500)
		},
		async alterarMarca() {
			const objParams = {
				idItemAditivoApostila: this.itemAditivoApostila.id,
				marca: this.itemAditivoApostila.novaMarca,
			}

			await this.$store.dispatch(actionTypes.ITEM_ADITIVO_APOSTILA.ALTERAR_MARCA_ITEM_ADITIVO_APOSTILA, objParams)
		},
	},
}
</script>
